<template>
  <div class="main">
    <div class="logo"></div>
  <div class="content resetpwd">
      <div class="title font-size24 color-msg">重置成功</div>
      <div class="font-size14 color-msg cue" >恭喜您，帐号<span>{{account}}</span>密码重置成功</div>
    <div class="font-size14 color-msg bottom-cue" >{{timer}}S自动跳转登录，<span @click="toLogin">立即跳转></span></div>
  </div>
  </div>
</template>
<script>
  import {mtvConfig as CONF} from '../services/services'
  export default {
    data () {
      return {
        account: '',
        timer: 5,
        setTimeOutObj: null
      }
    },
    created () {
      if (this.$route.params.account === undefined) {
        this.$router.push(CONF.urlList.ResetGetAccount.path + window.location.search)
      }
      this.account = this.$route.params.account
      this.setTimeOutFun()
    },
    methods: {
      setTimeOutFun () {
        let that = this
        that.setTimeOutObj = setInterval(function () {
          if (that.timer === 1) {
            that.toLogin()
          }
          that.timer--
        }, 1000)
      },
      toLogin () {
        clearTimeout(this.setTimeOutObj)
        let nextRoute = CONF.urlList.Login
        nextRoute.query = {}
        if (this.$route.query.callback) {
          nextRoute.query.callback = this.$route.query.callback
        }
        if (this.$route.query.connectid) {
          nextRoute.query.connectid = this.$route.query.connectid
        }
        this.$router.push(nextRoute)
      }
    }
  }
</script>
<style scoped>
  .resetpwd .bottom-cue span{color: #097ce0;  }
  .resetpwd .cue{text-align: center}
  .resetpwd .bottom-cue{text-align: center;margin-top: 19px;}
</style>



// WEBPACK FOOTER //
// ResetpwdSuccess.vue?29e655a6